module.exports = __webpack_public_path__ + "static/media/brand.41f23934.svg";